module.exports = __webpack_public_path__ + "static/media/img_money_packs@3x.91c14628.png";